"use client";

import { useConvexAuth } from "convex/react";
import { ReactNode } from "react";
import { SignInPage } from "@/app/auth/SignInPage";
import { useIsExchangingOAuthCode } from "@/components/OAuthCodeHandler";
import { usePathname } from "next/navigation";

const PUBLIC_PATHS = ["/accept-invite", "/accept-client-invite"];

export function AuthGate({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated } = useConvexAuth();
  const isExchangingCode = useIsExchangingOAuthCode();
  const pathname = usePathname();

  const isPublic = PUBLIC_PATHS.some((p) => pathname.startsWith(p));

  if (isLoading || isExchangingCode) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated && !isPublic) {
    return <SignInPage />;
  }

  return <>{children}</>;
}
